"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _ui = require("@alycecom/ui");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

var selectors = _interopRequireWildcard(require("../store/personalTemplateSettings.selectors"));

var actions = _interopRequireWildcard(require("../store/personalTemplateSettings.actions"));

var _TemplateItem = _interopRequireDefault(require("./TemplateItem"));

var TemplatesList = function TemplatesList(_ref) {
  var search = _ref.search,
      editTemplateId = _ref.editTemplateId,
      onToggleEdit = _ref.onToggleEdit;
  var dispatch = (0, _reactRedux.useDispatch)();
  var isLoaded = (0, _reactRedux.useSelector)(selectors.getIsLoaded);
  var templates = (0, _reactRedux.useSelector)((0, _react.useMemo)(function () {
    return selectors.getTemplatesBySearch(search);
  }, [search]));
  var handleSave = (0, _react.useCallback)(function (template) {
    dispatch(actions.updateTemplate(template));
  }, [dispatch]);
  var handleDelete = (0, _react.useCallback)(function (id) {
    dispatch(actions.deleteTemplate(id));
  }, [dispatch]);

  if (Object.values(templates).length === 0) {
    return /*#__PURE__*/_react.default.createElement(_material.Box, {
      pt: 5,
      pb: 1,
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center"
    }, isLoaded ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Box, {
      component: _ui.DashboardIcon,
      icon: "info-circle",
      mr: 1
    }), /*#__PURE__*/_react.default.createElement(_material.Typography, {
      className: "H3-Dark"
    }, "There's no templates data available.")) : /*#__PURE__*/_react.default.createElement(_ui.AlyceLoading, {
      isLoading: true
    }));
  }

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, Object.values(templates).map(function (template) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ui.Divider, {
      my: 3,
      shift: -8,
      mx: -4
    }), /*#__PURE__*/_react.default.createElement(_TemplateItem.default, {
      key: template.id,
      id: template.id,
      edit: editTemplateId === template.id,
      onToggleEdit: onToggleEdit,
      onSave: handleSave,
      onDelete: handleDelete
    }));
  }));
};

TemplatesList.propTypes = {
  search: _propTypes.default.string,
  editTemplateId: _propTypes.default.number,
  onToggleEdit: _propTypes.default.func.isRequired
};
TemplatesList.defaultProps = {
  search: '',
  editTemplateId: undefined
};
var _default = TemplatesList;
exports.default = _default;